var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2528 17.625C2.85349 17.625 2.51408 17.4852 2.23457 17.2057C1.95506 16.9262 1.8153 16.5868 1.8153 16.1875V2.53125H0.833008V1.09375H5.33717V0.375H11.6622V1.09375H16.1663V2.53125H15.184V16.1875C15.184 16.5708 15.0403 16.9062 14.7528 17.1937C14.4653 17.4812 14.1299 17.625 13.7465 17.625H3.2528ZM13.7465 2.53125H3.2528V16.1875H13.7465V2.53125ZM5.79238 14.1271H7.22988V4.56771H5.79238V14.1271ZM9.76947 14.1271H11.207V4.56771H9.76947V14.1271ZM3.2528 2.53125V16.1875V2.53125Z",
    fill: "#5F6369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.41333df91a7c03875a8b81a12d3ce6d3.svg";
export { ForwardRef as ReactComponent };